import styles from "./GameSelectPage.module.scss";

import { MouseEvent, useEffect, useRef, useState } from "react";

import FloatingButton from "../Shared/FloatingButton/FloatingButton";
import { GlobalState } from "../../redux/store";
import { Link } from "react-router-dom";
import { strings } from "../../util/language";
import { useSelector } from "react-redux";
import { FcSpeaker, FcUndo, FcVoicePresentation } from "react-icons/fc";
import { FiSettings } from "react-icons/fi";
import { GameType } from "../../models/GameType";

const IMAGE = "/images/memory5.png";

const GameSelectPage = () => {
  const { language } = useSelector((state: GlobalState) => state.settings);

  const style = {
    backgroundImage: `url(${IMAGE})`,
    backgroundSize: "cover",
  };

  const options: GameType[] = [
    { title: strings[language].gameSelectPage.addition, type: "+", id: 0 },
    {
      title: strings[language].gameSelectPage.multiplication,
      type: "*",
      id: 1,
    },
    { title: strings[language].gameSelectPage.subtraction, type: "-", id: 2 },
    { title: strings[language].gameSelectPage.division, type: "/", id: 3 },
  ];

  return (
    <div style={style} className={styles.selectPage}>
      <div className={styles.buttonContainer}>
        {options.map((option, index) => (
          <Link to={`/game/${option.id}`} className={styles.button} key={index}>
            <span className={styles.buttonText}>{option.title}</span>
          </Link>
        ))}
      </div>
      <Link to="/">
        <FloatingButton
          icon={<FcUndo size={30} className="floating-button-icon" />}
          style={{ top: "10px", left: "10px" }}
        />
      </Link>
      <Link to="/settings">
        <FloatingButton
          icon={<FiSettings size={30} className="floating-button-icon" />}
          style={{ top: "10px", right: "10px" }}
        />
      </Link>
    </div>
  );
};

export default GameSelectPage;
